interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  icon?: string;
  action?: React.ReactNode;
}

export default function SectionHeading({ title, subtitle, icon, action }: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5 md:mb-6">
      <div className="flex items-center gap-3">
        <span className="w-9 h-9 rounded-md bg-primary-100 text-primary-700 flex items-center justify-center">
          {icon ? <i className={`${icon} text-lg`} /> : <i className="ri-emotion-happy-line text-lg" />}
        </span>
        <div>
          <h2 className="font-heading font-bold text-lg md:text-xl text-foreground-950">{title}</h2>
          {subtitle && <p className="text-xs md:text-sm text-foreground-500 mt-0.5">{subtitle}</p>}
        </div>
      </div>
      {action}
    </div>
  );
}